/* index.tsx */

import { parserMessage } from "../parser";

import { CHAT_ROLE } from "../../configuration/genovAiConfig";
import { fetchWithToken } from "../interceptor";
import { iChatUserContext } from "../chatContext";
// import { getAPIResponse } from "../http";

export async function callHttpApi(
  currChatContext: iChatUserContext,
  accessToken: string,
  mail: string
) {
  let _url = "";

  console.log("CONTEXTO", currChatContext.filesSelected?.length);
  if (currChatContext.filesSelected?.length > 0) {
    _url = `/v1/comparador/completion/${currChatContext?.currChat.data_sources[0].parameters.vector_store_id}/${currChatContext?.currChat.data_sources[0].parameters.thread_id}`;
  } else {
    _url = `/v1/chat/completion`;
  }

  const _requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({
      role: CHAT_ROLE,
      question: JSON.stringify(currChatContext?.currChat.messages),
      index: currChatContext?.currChat.data_sources[0].parameters.index_name,
      semantic_configuration:
        currChatContext?.currChat.data_sources[0].parameters.semantic_configuration,
      temperature: currChatContext?.currChat.temperature,
      max_n_tokens: currChatContext?.currChat.max_tokens,
      mail: mail,
    }),
  };
  return await fetchWithToken(_url, _requestOptions);
}

export async function getAPIResponse(
  currChatContext: iChatUserContext,
  accessToken: string,
  mail: string,
  onChunkReceived: (chunk: any) => void,
  abortController: AbortController // Add AbortController as a parameter
): Promise<any> {
  return new Promise((resolve, reject) => {
    const chunkStringStream: any[] = [];

    try {
      callHttpApi(currChatContext, accessToken, mail)
        .then(async (response) => {
          if (response.status === 200) {
            const stream = response?.body;
            const reader = stream!.getReader();
            const readChunk = () => {
              reader
                .read()
                .then(({ value, done }) => {
                  if (abortController.signal.aborted) {
                    reject("Request aborted");
                    return;
                  }

                  if (done) {
                    parserMessage(chunkStringStream.join("")).then((chunk) => {
                      onChunkReceived(chunk);
                    });
                    resolve("End request");
                    return;
                  }

                  chunkStringStream.push(new TextDecoder().decode(value));
                  readChunk();
                })
                .catch((error) => {
                  console.error(error);
                  resolve([
                    {
                      index: 0,
                      delta: {
                        content:
                          "Oops, parece que hay problema de conexión con el servidor central.",
                      },
                      end_turn: false,
                      finish_reason: null,
                    },
                  ]);
                });
            };
            readChunk();
          } else {
            resolve([
              {
                index: 0,
                delta: {
                  content:
                    "Oops, parece que hay problema de conexión con el servidor central.",
                },
                end_turn: false,
                finish_reason: null,
              },
            ]);
          }
        })
        .catch((error) => {
          console.error("Error al realizar la llamada fetch:", error);
          resolve([
            {
              index: 0,
              delta: {
                context: {
                  messages: [
                    {
                      role: "tool",
                      content:
                        "Oops, parece que hay problema de conexión con el servidor central.",
                      end_turn: false,
                    },
                  ],
                },
              },
              end_turn: true,
              finish_reason: null,
            },
          ]);
        });
    } catch (error) {
      console.info("Error");
    }
  });
}

export async function callAiOperator(
  currChatContext: iChatUserContext | null,
  url: string,
  onChunkReceived: (chunk: any) => void,
  abortController: AbortController
): Promise<any> {
  return new Promise(async (resolve, reject) => {
    const _requestOptions = {
      method: "POST",
      body: JSON.stringify({
        role: CHAT_ROLE,
        question: JSON.stringify(currChatContext?.currChat.messages),
        index: currChatContext?.currChat.data_sources[0].parameters.index_name,
        semantic_configuration:
          currChatContext?.currChat.data_sources[0].parameters
            .semantic_configuration,
        temperature: currChatContext?.currChat.temperature,
        max_n_tokens: currChatContext?.currChat.max_tokens,
      }),
      signal: abortController.signal, // Add the signal to the request options
    };

    const response = await fetchWithToken(url, _requestOptions);
    const readerStream = response.body?.getReader();
    if (!readerStream) {
      resolve([
        {
          index: 0,
          delta: {
            content:
              "Oops, parece que hay problema de conexión con el servidor central.",
          },
          end_turn: false,
          finish_reason: null,
        },
      ]);
      return;
    }
    let apiResponse = [];

    const readChunk = () => {
      readerStream
        .read()
        .then(({ value, done }) => {
          if (abortController.signal.aborted) {
            reject("Request aborted");
            return;
          }
          if (done) {
            resolve("End request");
            return;
          }
          const chunkString = new TextDecoder().decode(value);
          parserMessage(chunkString).then((chunk) => {
            apiResponse.push(...chunk);
            onChunkReceived(chunk);
          });
          readChunk();
        })
        .catch((error) => {
          console.error(error);
          resolve([
            {
              index: 0,
              delta: {
                content:
                  "Oops, parece que hay problema de conexión con el servidor central.",
              },
              end_turn: false,
              finish_reason: null,
            },
          ]);
        });
    };
    readChunk();
  });
}
